'use client';

import { useColorScheme } from '@mui/material/styles';
import { COLOR_SCHEME } from '@/constants/colorScheme';

/**
 * Resolved light/dark scheme for UI that must match the active MUI color scheme.
 * Prefer this over `useTheme().palette.mode` when using `colorSchemes` + CSS variables,
 * since the latter often stays on the default palette while `data-mui-color-scheme` drives the page.
 */
export function useResolvedColorScheme() {
  const { mode, systemMode } = useColorScheme();
  const resolvedScheme =
    mode === COLOR_SCHEME.SYSTEM
      ? (systemMode ?? COLOR_SCHEME.LIGHT)
      : (mode ?? COLOR_SCHEME.LIGHT);
  return {
    resolvedScheme,
    isDarkMode: resolvedScheme === COLOR_SCHEME.DARK,
  };
}
